import { useEffect } from 'react';

/**
 * ページタイトルを動的に設定するカスタムフック
 * @param pageTitle - ページ名（日本語）
 * @example usePageTitle('ログイン'); // → "SALONHUB：ログイン"
 */
export const usePageTitle = (pageTitle: string): void => {
  useEffect(() => {
    document.title = `SALONHUB：${pageTitle}`;

    // クリーンアップ: コンポーネントがアンマウントされたらデフォルトタイトルに戻す
    return () => {
      document.title = 'SALONHUB：サロンハブ';
    };
  }, [pageTitle]);
};
